import { useCallback, useEffect } from "react";
import { usePartnerInfo } from "../usePartnerInfoContext";
import { useGetClinicStorageInfo } from "./useGetClinicStorageInfo";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";

export const useGetClinicStorageInfoWrapper = () => {
    const { getClinicStorageInfo, data, loading, error } = useGetClinicStorageInfo();
    const { setInfobar, setLoader, reset } = usePartnerInfo();

    useEffect(() => {
            if (error) {
                logger.logError(`Failed to get Clinic Storage.`)
                setInfobar({message: error, messageType: InfoMessageType.error});
            }
        }, [error, setInfobar])

    const getClinicStorageInfoDetails = useCallback((clinicId:string) => {
        reset();
        getClinicStorageInfo(clinicId);
    }, [reset, getClinicStorageInfo])
    
    useEffect(()=> {
        setLoader(loading);
    }, [loading, setLoader])
    

    return { getClinicStorageInfoDetails, data, loading, error };
}